module.exports = __webpack_public_path__ + "img/tips_bgc_bg.bbd057d1.png";